import React, { useEffect, memo, useState } from 'react';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import UnstyledHeading from '@components/shared/unstyled-heading';
import ErrorPage from '@components/site-error-page';

import { fetchPublicDataTypes } from '@actions/data-types-actions';
import { getConfig, getPublicConfig } from '@components/config/selectors';
import { getMapCategory } from '@selectors/data-types-selector';
import { fetchPublicConfig } from '@components/config/actions';

import './public.scss';

const PublicLayout = ({ children }) => {
  const dispatch = useDispatch();
  const dataTypes = useSelector(state => state.dataTypes);
  const config = useSelector(getConfig);
  const publicConfig = useSelector(getPublicConfig);
  const categoryValues = useSelector(getMapCategory);
  const {siteLoaded, publicSiteError} = useSelector(getConfig);

  const [pendingUpdate, setPendingUpdate] = useState(true);

  useEffect(() => dispatch(fetchPublicDataTypes()), [dispatch]);
  useEffect(() => {
    if (siteLoaded && categoryValues && pendingUpdate) {
      dispatch(fetchPublicConfig(categoryValues));
      setPendingUpdate(false);
    }
  }, [dispatch, siteLoaded, categoryValues, pendingUpdate, setPendingUpdate]);

  const requiredTypes = [
    'agency',
    'map_category_type',
    'map_category',
    'user'
  ];

  if (publicSiteError) {
    return <ErrorPage publicPage/>;
  }

  // Check that the configuration and all required data types are loaded before
  // displaying the page contents.
  if (requiredTypes.every(requiredType => !isEmpty(dataTypes[requiredType]) && publicConfig)) {
    return (
      <main styleName="public-wrap">
        <UnstyledHeading rank={1} ariaOnly>Coordinate {config.cityName} public form</UnstyledHeading>
        <div styleName="public-body">
          {children}
        </div>
      </main>
    );
  }

  return null;
};

PublicLayout.propTypes = {
  children: PropTypes.element
};

export default memo(PublicLayout);
